import { isNil } from 'lodash/fp'
import React from 'react'
import { useRedirect } from 'react-admin'

const env = process.env['ENV'] as string
const url = {
  prd: 'https://entry.terashite.jp',
  stg: 'https://entry-stg.terashite.jp',
  int: 'https://entry-int.dev.terashite.jp',
  dev: 'https://entry.dev.terashite.jp',
  exp: 'https://entry-exp.dev.terashite.jp',
  local: 'https://local:5173'
}[env]

export const CompleteForm: React.FC = () => {
  const redirect = useRedirect()
  React.useEffect(() => {
    if (isNil(url)) return
    redirect(`${url}/sign`)
  })
  return <></>
}
